module.exports = __webpack_public_path__ + "static/media/truck_top.cb648524.svg";